import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import Logo from "@/components/Logo";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", ...p }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.65, delay, ease: EASE }}
    {...p}
  >
    {children}
  </motion.div>
);

export const SmallCaps = ({ children, ...p }) => (
  <span
    className="font-body font-bold text-[11px] tracking-[0.22em] uppercase text-ink/50"
    {...p}
  >
    {children}
  </span>
);

export function ScreenTop({ label }) {
  return (
    <div className="flex items-center justify-between px-5 pt-6 max-w-2xl mx-auto w-full">
      <Logo size={44} />
      <SmallCaps data-testid="screen-step-label">
        {label || "POSSO IS COMING."}
      </SmallCaps>
    </div>
  );
}

export function PrimaryButton({
  busy,
  disabled,
  children,
  testId,
  onClick,
  type = "submit",
  bg = "#FF6BAA",
  fg = "#111111",
}) {
  const isOutline = bg === null;
  const needsInkBorder = isOutline || bg.toUpperCase() === "#FFFFFF";
  return (
    <button
      data-testid={testId}
      type={type}
      onClick={onClick}
      disabled={busy || disabled}
      className="w-full min-h-[64px] rounded-full border-2 font-display text-xl uppercase tracking-wide inline-flex items-center justify-center gap-2 transition-[transform,opacity,background-color,color,border-color] duration-200 hover:brightness-95 active:scale-[0.97] disabled:pointer-events-none"
      style={{
        backgroundColor: isOutline ? "transparent" : bg,
        color: isOutline ? "#111111" : fg,
        borderColor: needsInkBorder ? "#111111" : bg,
        opacity: disabled && !busy ? 0.45 : 1,
      }}
    >
      {busy ? (
        <Loader2 className="w-6 h-6 animate-spin" strokeWidth={2.5} />
      ) : (
        children
      )}
    </button>
  );
}

export const ErrorBox = ({ msg }) =>
  msg ? (
    <p
      data-testid="form-error"
      role="alert"
      className="mt-4 text-sm font-medium text-[#C2271B]"
    >
      {msg}
    </p>
  ) : null;
